import * as React from 'react';

import { ClientLogger } from 'bernie-client';

import { PropertyListingBadgeModel } from 'models';

import { UitkLayoutPosition } from 'uitk-react-layout-position';

import { fetchAndLogStatus } from 'utils/fetch-status-utils';

import { BadgeGenerator } from 'components/common/badge-generation';

interface RenderBadgeProps {
  propertyListingBadgeModel: PropertyListingBadgeModel;
  travelAd: {
    impressionTrackingUrl: string;
  };
  pinned?: boolean;
}

const travelAdImpressions = [];
export const PrimaryBadge: React.FunctionComponent<RenderBadgeProps> = ({ propertyListingBadgeModel, travelAd, pinned }) => {
  const { primary } = { ...propertyListingBadgeModel };
  const { impressionTrackingUrl } = { ...travelAd };

  if (typeof window !== 'undefined' && impressionTrackingUrl && !travelAdImpressions.includes(impressionTrackingUrl)) {
    travelAdImpressions.push(impressionTrackingUrl);
    fetchAndLogStatus(
      impressionTrackingUrl,
      ClientLogger.getLoggerWithIdentifier('pwa.component.title-badge'),
      'TRAVELAD_IMPRESSION_FAILURE',
      null
    );
  }

  const primaryIsSafe = primary && (primary.text || primary.icon || primary.mark);

  const position = pinned
    ? { top: 'twelve' as 'twelve', left: 'three' as 'three', zindex: 'layer3' as 'layer3' }
    : { top: 'one' as 'one', left: 'three' as 'three', zindex: 'layer3' as 'layer3' };

  return (
    <React.Fragment>
      {primaryIsSafe && (
        <UitkLayoutPosition type="absolute" position={position}>
          <BadgeGenerator badge={primary} badgeClasses="all-t-margin-two" dataStid="primary-badge" />
        </UitkLayoutPosition>
      )}
    </React.Fragment>
  );
};

PrimaryBadge.displayName = 'PrimaryBadge';
